import { classNames } from "../../../helpers/classNames";

const Textarea = ({
  label,
  labelClasses,
  inputClasses,
  inputPlaceholder,
  inputValue,
  inputName,
  errorType,
  required,
  onChange = () => {},
  ...props
}) => {
  return (
    <>
      <div className="relative space-y-1 w-full">
        {label && (
          <div
            className={classNames(
              "text-xs font-medium text-text-disabled   mb-1",
              labelClasses,
            )}
          >
            {label}
            {required && (
              <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
                <i className="fa-solid fa-asterisk"></i>
              </span>
            )}
          </div>
        )}
        <div className="relative flex">
          <textarea
            className={classNames(
              "w-full h-20 rounded-md placeholder:text-text-disabled dark:bg-gray-200/20 dark:border-gray-500 dark:text-gray-200 dark:placeholder:text-gray-200 bg-white border border-slate-200 shadow-sm px-3   text-base text-black !ring-0 !outline-0 focus:border-palatte transition-all duration-200 ",
              inputClasses,
            )}
            placeholder={inputPlaceholder}
            name={inputName}
            value={inputValue}
            onChange={onChange}
            {...props}
          ></textarea>
        </div>
        {errorType && errorType === "error" && (
          <div className="text-xs text-red-600 mt-1">
            <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
            This field is required
          </div>
        )}
        {errorType && errorType === "warning" && (
          <div className="text-xs text-amber-600 mt-1">
            <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
            This field has a warning
          </div>
        )}
        {errorType && errorType === "success" && (
          <div className="text-xs text-green-600 mt-1">
            <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
            Verified
          </div>
        )}
      </div>
    </>
  );
};

export default Textarea;
